import { SubscriptionPlatform } from "@next-platform/packages-ts-types";
export const PLAN_STATE = {
    FREE: "free",
    GRACE: "grace",
    CANCELLED: "cancelled",
    PAUSED: "paused",
    EXPIRED: "expired",
    ONE_TIME_ACTIVE: "oneTimeActive",
    RECURRING_ACTIVE: "recurringActive",
};
export const SUBSCRIPTION_MANAGE_DESTINATION = {
    OVERVIEW: "overview",
    PORTAL: "portal",
    SUBSCRIBE: "subscribe",
    CHECKOUT: "checkout",
    SUBSCRIBE_STAR: "subscribestar",
    NONE: "none",
};
export const RECURRING_MANAGEABLE_PLATFORMS = new Set([
    SubscriptionPlatform.REVENUE_CAT,
    SubscriptionPlatform.STICKY,
    SubscriptionPlatform.BOOSTY,
    SubscriptionPlatform.SUBSCRIBE_STAR,
]);
